module.exports = __webpack_public_path__ + "./img/settings.f7164cc7223e2538cdff4a5bc9f63cc2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/settings.png
// module id = ./assets/images/settings.png
// module chunks = 0